let msg: () => void
const BaseUrl = ''
const BaseResourceUrl = ''

const Post = (
  url: string,
  done: (res: any) => void,
  error?: (res: any) => void,
  isCache?: boolean,
  isMax?: boolean,
  isRe?: boolean,
  isFullLoading?: boolean
) => {
  const cache = localStorage.getItem(url)
  const node = document.getElementById('loading-m')
  if (isFullLoading) {
    node!.style.display = 'block'
  }
  if (cache !== null && isCache) {
    done(JSON.parse(cache))
    if (isFullLoading) {
      node!.style.display = 'none'
    }
  } else {
    fetch(BaseUrl + (isMax ? '/MaxApi' : '/ReadApi') + url, {
      method: 'POST',
      mode: 'cors',
    })
      .then((res) => {
        return res.json()
      })
      .then((res: any) => {
        if (msg) {
          msg()
        }
        done(res)
        if (isCache) {
          localStorage.setItem(url, JSON.stringify(res))
        }
        if (isFullLoading) {
          node!.style.display = 'none'
        }
      })
      .catch((res: any) => {
        error === undefined ? ErrorDefault(res) : error(res)
        if (isRe) {
          if (msg) {
            msg()
          }
          // Toast.loading('网络异常，正在重试第:' + index++ + '次', 0);
          setTimeout(() => {
            Post(url, done, error, isCache, isMax, isRe)
          }, 5000)
        } else {
          // Toast.fail('网络异常, 获取数据失败', 5);
        }
        if (isFullLoading) {
          node!.style.display = 'none'
        }
      })
  }
}

const Login = (
  phone: string,
  password: string,
  done: (res: Login) => void,
  error?: (res: any) => void
) => {
  let params = '/login?phone=' + phone + '&password=' + password
  Post(params, done, error, false, false, false, false)
}

const Register = (
  phone: string,
  code: string,
  authorizeCode: string,
  password: string,
  done: (res: Register) => void,
  error?: (res: any) => void
) => {
  let params =
    '/register?phone=' +
    phone +
    '&code=' +
    code +
    '&authorizeCode=' +
    authorizeCode +
    '&password=' +
    password
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取手机验证码
 * @param phone
 * @param type 验证码用途 0注册 1绑定手机号 2忘记密码
 * @param done
 * @param error
 */
const GetCode = (
  phone: string,
  type: number = 0,
  done: (res: GetCode) => void,
  error?: (res: any) => void
) => {
  let params = '/getCode?phone=' + phone + '&type=' + type
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取首页
 * @param type
 * @param done
 * @param error
 */
const GetLookHome = (
  type: string,
  done: (res: LookHome) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  if (type == null) {
    type = '1'
  }
  let params =
    '/lookHomeOrigin?userid=' +
    userid +
    '&type=' +
    type +
    '&pageIndex=1&pageSize=3' //'/home?userid=' + userid;
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取分类
 * @param classifyId
 * @param sorttype
 * @param pageIndex
 * @param done
 * @param error
 */
const GetClassifyItem = (
  classifyId: string,
  sorttype: number,
  pageIndex: number,
  done: (res: ClassifyItem) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  let params =
    '/classifyItem?userid=' +
    userid +
    '&classifyId=' +
    classifyId +
    '&pageIndex=' +
    pageIndex +
    '&pageSize=30&sorttype=' +
    sorttype
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取搜索
 * @param keyword
 * @param type
 * @param sorttype
 * @param pageIndex
 * @param done
 * @param error
 */
const GetSearch = (
  keyword: string,
  type: string,
  sorttype: number,
  pageIndex: number,
  done: (res: ClassifyItem) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  let params =
    '/search?userid=' +
    userid +
    '&type=' +
    type +
    '&pageIndex=' +
    pageIndex +
    '&pageSize=30&sorttype=' +
    sorttype +
    '&keyword=' +
    keyword
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取图书详情
 * @param bookID
 * @param done
 * @param error
 */
const GetBookDetails = (
  bookID: string,
  done: (res: BookDetails) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  let params = '/bookDetails?userid=' + userid + '&bookID=' + bookID
  Post(params, done, error, false, false, false, false)
}

/**
 * 获取有声详情
 * @param bookID
 * @param done
 * @param error
 */
const GetQuiteDetails = (
  bookID: string,
  done: (res: QuiteDetails) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  let params = '/quiteDetails?userid=' + userid + '&bookID=' + bookID
  Post(params, done, error, false, false, false, false)
}

/**
 * 获取忘记密码
 * @param phone 手机
 * @param code 验证码
 * @param passWord 密码
 * @param done
 * @param error
 */
const GetFindPassWord = (
  phone: string,
  code: string,
  passWord: string,
  done: (res: BaseType<{}>) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  let params =
    '/findPassWord?phone=' + phone + '&code=' + code + '&passWord=' + passWord
  Post(params, done, error, false, false, false, false)
}

/**
 * # 获取书内容
 * @param LibraryId
 * @param pagesize
 * @param pageindex
 * @param done
 * @param error
 */
const GetTxt = (
  LibraryId: number,
  pagesize: number,
  pageindex: number,
  done: (res: Txt) => void,
  error?: (res: any) => void
) => {
  const params =
    '/GetTXT?libraryid=' +
    LibraryId +
    '&pagesize=' +
    pagesize +
    '&pageindex=' +
    pageindex
  Post(params, done, error, false, true)
}

/**
 * # 获取书信息
 * @param LibraryId
 * @param pagesize
 * @param pageindex
 * @param done
 * @param error
 */
const GetBookInfo = (
  LibraryId: number,
  hCount: number,
  vCount: number,
  done: (res: BookInfo) => void,
  error?: (res: any) => void
) => {
  const params =
    '/GetBookInfo?libraryid=' +
    LibraryId +
    '&hCount=' +
    hCount +
    '&vCount=' +
    vCount
  Post(params, done, error, false, true)
}

/**
 * # 阅读状态
 * @param bookId
 * @param StatisticsType
 * @param done
 * @param error
 */
const Statistics = (
  bookId: number,
  StatisticsType: number,
  done: (res: Txt) => void,
  error?: (res: any) => void
) => {
  const userid = window.userID
  if (userid === NaN) return
  const params =
    '/Statistics?bookId=' +
    bookId +
    '&userId=' +
    userid +
    '&StatisticsType=' +
    StatisticsType
  Post(params, done, error, false, false)
}

const ErrorDefault = (res: any) => {
  console.log(res)
}

const GetOSSUri = (name: string) => {
  return fetch(BaseUrl + '/api/OSS/GetUri?name=' + name).then((r) => r.json())
}

export {
  BaseResourceUrl,
  BaseUrl,
  Login,
  Register,
  GetCode,
  GetFindPassWord,
  GetLookHome,
  GetClassifyItem,
  GetBookDetails,
  GetTxt,
  GetBookInfo,
  GetQuiteDetails,
  GetSearch,
  Statistics,
  GetOSSUri,
}
